export const baseTableConfig = {
    items: [],
    fields: [],
    order: "desc",
    rows: 5,
    page: 1,
    total_pages: 1,
    loading: false,
    hover: true,
    pagination: true,
    sorter: {
        external: true,
        resetable: true,
    },
    sorterValue: {},
    size: "sm",
    columnFilter: true,
    allFields: [],
    itemsPerPageSelect: true,
    export: null,
    columnFilter: {
        external: true,
        lazy: true,
    },
    responsive: true,
    columnFilterValue: {},
    itemSelected: null,

    findFieldByKey(key) {
        return this.fields.find((field) => {
            return field.key == key;
        });
    },
    findIndexFieldByKey(key) {
        return this.fields.findIndex((field) => {
            return field.key == key;
        });
    },
    setFieldProperty(fieldKey, fieldPropertyKey, fieldPropertyValue) {
        let findIndex = this.findIndexFieldByKey(fieldKey)
        if (findIndex) {
            this.fields[findIndex][fieldPropertyKey] = fieldPropertyValue;
        }
        return this;
    }

}

export const baseFieldConfig = {
    _active: false,
    fixed: false,
    _filter: false,
    filter: false
}

export const normalizeTableField = (field, config = {}) => {
    if (typeof field === 'string' || field instanceof String) {
        return {
            ...baseFieldConfig,
            ...config,
            key: field,
            label: field,
        }
    } else {
        return {
            ...baseFieldConfig,
            ...config,
            ...field,
        }
    }

}


export function isReservedField(field){
    const tableReservedFields = ["_options", "_selected"];
    if (typeof field === "string" && tableReservedFields.includes(field))
        return true;
    else if (field.key && tableReservedFields.includes(field.key))
        return true;
    else
        return false;
}
